import { httpPost } from '@/services/http';

export interface ContactEmailRequest {
  name: string;
  email: string;
  subject: string;
  message: string;
}

export async function sendContactEmail(data: ContactEmailRequest): Promise<void> {
  await httpPost<void>('/public/contact', data);
}
